import {
  getUserWallets
} from "./chunk-DEJ436V5.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/wallet/userWallets.ts
import { useQuery } from "@tanstack/react-query";
var useGetUserWallets = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getUserWallets", props],
    queryFn: () => getUserWallets(props)
  }, options));
};

export {
  useGetUserWallets
};
//# sourceMappingURL=chunk-GVTBIL6U.mjs.map